import '../Player.styles.css';

import { FC, useMemo, useState } from 'react';

import { Permission } from '../../../model/enumeration/Permission.enum';
import authStore from '../../../store/AuthStore';
import permissionStore from '../../../store/PermissionStore';
import AvailableBotsForSeat from '../../AvailableBotsForSit/AvailableBotsForSeat';
import { EmptyPlayerProps } from './EmptyPlayer.types';

const EmptyPlayer: FC<EmptyPlayerProps> = ({
  tableId,
  gameType,
  room,
  limit,
  tableUnion,
  tablePosition,
  isolated,
  place,
  tablePlayerCount,
}) => {
  const [isAvailableBotsDialogVisible, setIsAvailableBotsDialogVisible] =
    useState(false);

  const hasManageBotsSeatingPermission = useMemo(
    () => permissionStore.hasPermission(Permission.MANAGE_BOTS_SEATING),
    [authStore.authenticatedUser],
  );

  return (
    <div
      className={`player-wrapper d-inline-block rounded-5 px-3 p-2 text-center position-absolute${
        hasManageBotsSeatingPermission && !isolated ? ' cursor-pointer' : ''
      }`}
      data-ignore-outside-click={true}
      onClick={() =>
        !isAvailableBotsDialogVisible &&
        !isolated &&
        setIsAvailableBotsDialogVisible(true)
      }
      style={
        tablePosition && {
          left: tablePosition.playerX,
          top: tablePosition.playerY,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        }
      }
    >
      {hasManageBotsSeatingPermission && !isolated && (
        <>
          <div className="w-100 h-100 take-seat d-flex flex-column justify-content-center gap-4">
            <div>
              <i className="d-block pi pi-sort-down-fill" />
              <i className="d-block pi pi-sort-down-fill" />
            </div>
            <div>Take Seat</div>
          </div>
          <AvailableBotsForSeat
            fromLobbyTable={false}
            tableId={tableId}
            room={room}
            gameType={gameType}
            limit={limit}
            union={tableUnion}
            isVisible={isAvailableBotsDialogVisible}
            isTableFull={false}
            place={place}
            tablePlayerCount={tablePlayerCount}
            onHide={() =>
              isAvailableBotsDialogVisible &&
              setIsAvailableBotsDialogVisible(false)
            }
          />
        </>
      )}
    </div>
  );
};

export default EmptyPlayer;
